import { from as observableFrom, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
    Component,
    OnInit,
    OnDestroy,
    Input,
    SimpleChanges,
    OnChanges,
    ViewChild,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
    ViewEncapsulation
} from '@angular/core';
import { LinkItem } from '@sportlogiq/main/shared/sl-types';
import { MatLegacyTabNav as MatTabNav } from '@angular/material/legacy-tabs';

@Component({
    selector: 'link-renderer',
    templateUrl: './link-renderer.component.html',
    styleUrls: ['./link-renderer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class LinkRendererComponent implements OnInit, OnDestroy, OnChanges {
    @Input() links: LinkItem[];
    @Input() tabs: boolean;
    @Input() tabNavExactMatch: boolean;
    @Input() stretchTabs = false;
    @Input() animationDuration = '0';

    @ViewChild(MatTabNav) navBar: MatTabNav;

    private destroy$ = new Subject<boolean>();
    constructor(
        private _cd: ChangeDetectorRef
    ) { }

    ngOnInit() {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        observableFrom((<any>document).fonts.ready).pipe(
            takeUntil(this.destroy$))
            .subscribe(() =>
                this.updateInkBarSize()
            );
    }

    ngOnDestroy() {
        // Unsubscribe from streams using takeUntil()
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    // mis alignment issue
    // https://github.com/angular/material2/issues/3469
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.links?.currentValue) {
            this.links = this.links.filter(x => x.visibility ? x.visibility() : true);
        }
        this.tabNavExactMatch = !!this.tabNavExactMatch;

        this._cd.markForCheck();
    }

    updateInkBarSize() {
        if (this.navBar) {
            this.navBar.updateActiveLink();
        }
    }
}
